module.exports = __webpack_public_path__ + "static/img/title.46e2612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.png
// module id = 05xs
// module chunks = 1